/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free secure password generator. Create strong, random passwords with custom length, numbers, symbols and more — generated in your browser, never sent anywhere.`)
};

const es_pw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de contraseñas seguro y gratuito. Crea contraseñas aleatorias y fuertes con longitud personalizada, números, símbolos y más — generadas en tu navegador, nunca se envían a ningún lado.`)
};

const de_pw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Passwortgenerator. Erstellen Sie starke, sichere Zufallspasswörter mit benutzerdefinierten Längen, Zahlen, Symbolen und mehr — generiert in Ihrem Browser, niemals irgendwo gesendet.`)
};

const nl_pw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis veilige wachtwoordgenerator. Creëer sterke, willekeurige wachtwoorden met aangepaste lengte, getallen, symbolen en meer — gegenereerd in je browser, nooit ergens verzonden.`)
};

const fr_pw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de mot de passe sécurisé gratuit. Créez des mots de passe aléatoires forts avec longueur personnalisée, chiffres, symboles et plus — générés dans votre navigateur, jamais envoyés nulle part.`)
};

const it_pw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di password sicuro gratuito. Crea password forti e casuali con lunghezza, numeri, simboli e altro personalizzati — generate nel tuo browser, mai inviate da nessuna parte.`)
};

const pt_br2_pw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de senhas seguro gratuito. Crie senhas fortes e aleatórias com comprimento personalizado, números, símbolos e muito mais — geradas em seu navegador, nunca enviadas para lugar nenhum.`)
};

const pt_pw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de senhas seguro e gratuito. Crie senhas fortes e aleatórias com comprimento personalizado, números, símbolos e muito mais — geradas no seu navegador, nunca enviadas para lado nenhum.`)
};

const ja_pw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のセキュアなパスワードジェネレーター。カスタム長、数字、記号などを使用してブラウザで強力でランダムなパスワードを作成できます。ジェネレーターは暗号学的に安全なランダム性を使用し、どこにも送信されません。`)
};

const zh_pw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费安全密码生成器。创建具有自定义长度、数字、符号等的强随机密码——在浏览器中生成，绝不会发送到任何地方。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_meta_description", locale)
	if (locale === "en") return en_pw_meta_description(inputs)
	if (locale === "es") return es_pw_meta_description(inputs)
	if (locale === "de") return de_pw_meta_description(inputs)
	if (locale === "nl") return nl_pw_meta_description(inputs)
	if (locale === "fr") return fr_pw_meta_description(inputs)
	if (locale === "it") return it_pw_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_pw_meta_description(inputs)
	if (locale === "pt") return pt_pw_meta_description(inputs)
	if (locale === "ja") return ja_pw_meta_description(inputs)
	return zh_pw_meta_description(inputs)
};